// https://www.coursera.org/api/thirdPartyOrganizationEmailDomains.v1

export default {
  elements: [
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'canaldigital.dk',
      domainId: 'canaldigital.dk',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'br.loreal.com',
      domainId: 'br.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'cybercity.dk',
      domainId: 'cybercity.dk',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'bredband.com',
      domainId: 'bredband.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvla.com.uy',
      domainId: 'directvla.com.uy',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvtlc.com',
      domainId: 'directvtlc.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'ar.loreal.com',
      domainId: 'ar.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'dgrh.loreal.com',
      domainId: 'dgrh.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'mJcDv3C1TEmy0nGTTv4R4Q',
      id: 'hec.edu',
      domainId: 'hec.edu',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'ad.local',
      domainId: 'ad.local',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'exchange.research.att.com',
      domainId: 'exchange.research.att.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'gpit.com',
      domainId: 'gpit.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directv.cl',
      domainId: 'directv.cl',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'intl.att.com',
      domainId: 'intl.att.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'mapsolutions.mo',
      domainId: 'mapsolutions.mo',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'be.loreal.com',
      domainId: 'be.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'itcosmetics.com',
      domainId: 'itcosmetics.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'decleor-us.com',
      domainId: 'decleor-us.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: '4tel.no',
      domainId: '4tel.no',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'cn.loreal.com',
      domainId: 'cn.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'YBdFYsVERS6jMoBN3TmhqQ',
      id: 'booking.com',
      domainId: 'booking.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvla.com.ve',
      domainId: 'directvla.com.ve',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'grameenphone.com',
      domainId: 'grameenphone.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'kiehls-usa.com',
      domainId: 'kiehls-usa.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'asie.loreal.com',
      domainId: 'asie.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'mapsolutions.no',
      domainId: 'mapsolutions.no',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'de.loreal.com',
      domainId: 'de.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'mcb-loreal.com',
      domainId: 'mcb-loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'canaldigital.com',
      domainId: 'canaldigital.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'grci.com',
      domainId: 'grci.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'labs.att.com',
      domainId: 'labs.att.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvpr.com',
      domainId: 'directvpr.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'logicshair-usa.com',
      domainId: 'logicshair-usa.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'hk.loreal.com',
      domainId: 'hk.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'o6BY46EoTsKqMC2NltqEWg',
      id: 'gemalto.com',
      domainId: 'gemalto.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'aeromobile.net',
      domainId: 'aeromobile.net',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'marlink.com',
      domainId: 'marlink.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'it.loreal.com',
      domainId: 'it.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'carolsdaughter.com',
      domainId: 'carolsdaughter.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'canaldigital.fi',
      domainId: 'canaldigital.fi',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'jb.digi.com.my',
      domainId: 'jb.digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'LYV4YXuWQNOp6e3qq8z4Zg',
      id: 'kpmg.com.au',
      domainId: 'kpmg.com.au',
    },
    {
      thirdPartyOrganizationId: '2BweSzrbQCKFDukxmPvOpg',
      id: 'elsevier.com',
      domainId: 'elsevier.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'bravida.no',
      domainId: 'bravida.no',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvla.com.ar',
      domainId: 'directvla.com.ar',
    },
    {
      thirdPartyOrganizationId: '90D6BAljQUKukxUlWhvESA',
      id: 'fmr.com',
      domainId: 'fmr.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'kyivstar.net',
      domainId: 'kyivstar.net',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'lacome-usa.com',
      domainId: 'lacome-usa.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'ktn.digi.com.my',
      domainId: 'ktn.digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'clarisonic.com',
      domainId: 'clarisonic.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'mcp.com',
      domainId: 'mcp.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'kr.loreal.com',
      domainId: 'kr.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvtt.com',
      domainId: 'directvtt.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'digi.com.my',
      domainId: 'digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'conax.com',
      domainId: 'conax.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'au.loreal.com',
      domainId: 'au.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'grandpripejd.rs',
      domainId: 'grandpripejd.rs',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'kjedehuset.no',
      domainId: 'kjedehuset.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'glocalnet.com',
      domainId: 'glocalnet.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directv.com.ec',
      domainId: 'directv.com.ec',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'il.loreal.com',
      domainId: 'il.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'ca.loreal.com',
      domainId: 'ca.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'bcaRX2_HSH633gtHRgIGhg',
      id: 'juliusbaer.com',
      domainId: 'juliusbaer.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'europolitan.telenor.com',
      domainId: 'europolitan.telenor.com',
    },
    {
      thirdPartyOrganizationId: 'LYV4YXuWQNOp6e3qq8z4Zg',
      id: 'kpmg.com',
      domainId: 'kpmg.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'cz.loreal.com',
      domainId: 'cz.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'fr.loreal.com',
      domainId: 'fr.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'kharkiv.kyivstar.net',
      domainId: 'kharkiv.kyivstar.net',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'at.loreal.com',
      domainId: 'at.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'dtac.co.th',
      domainId: 'dtac.co.th',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directv.pe',
      domainId: 'directv.pe',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'lviv.kyivstar.net',
      domainId: 'lviv.kyivstar.net',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'matrix.com',
      domainId: 'matrix.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'luxe.loreal.com',
      domainId: 'luxe.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'canaldigital.no',
      domainId: 'canaldigital.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'mcpinc.biz',
      domainId: 'mcpinc.biz',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'bibob.dk',
      domainId: 'bibob.dk',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'jp.loreal.com',
      domainId: 'jp.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directvla.com.co',
      domainId: 'directvla.com.co',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'maybelline.com',
      domainId: 'maybelline.com',
    },
    {
      thirdPartyOrganizationId: 'msXsh351QBiKERwBEnTxPQ',
      id: 'essec.edu',
      domainId: 'essec.edu',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'directv.com',
      domainId: 'directv.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'crimea.kyivstar.net',
      domainId: 'crimea.kyivstar.net',
    },
    {
      thirdPartyOrganizationId: 'ibWwRHhNQy2j24yTzlB0vA',
      id: 'coursera.org',
      domainId: 'coursera.org',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'datametrix.no',
      domainId: 'datametrix.no',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'ch.loreal.com',
      domainId: 'ch.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'lancome-usa.com',
      domainId: 'lancome-usa.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'galnet.as',
      domainId: 'galnet.as',
    },
    {
      thirdPartyOrganizationId: 'vG1Gc0bJTuCr955UWhMlyQ',
      id: 'ibm.com',
      domainId: 'ibm.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'loreal.com',
      domainId: 'loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'canaldigital.se',
      domainId: 'canaldigital.se',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'bluegarden.dk',
      domainId: 'bluegarden.dk',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'globul.bg',
      domainId: 'globul.bg',
    },
    {
      thirdPartyOrganizationId: 'B6feNmSCS-q4fwL8dAeulQ',
      id: 'deshaw.com',
      domainId: 'deshaw.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'dnepr.kyivstar.net',
      domainId: 'dnepr.kyivstar.net',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'digitania.com.pk',
      domainId: 'digitania.com.pk',
    },
    {
      thirdPartyOrganizationId: '2BweSzrbQCKFDukxmPvOpg',
      id: 'lexisnexis.com',
      domainId: 'lexisnexis.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'baxterofcalifornia.com',
      domainId: 'baxterofcalifornia.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'cbb.dk',
      domainId: 'cbb.dk',
    },
    {
      thirdPartyOrganizationId: 'JaV_tHwGRoqfUQYYD8yNOw',
      id: 'adobe.com',
      domainId: 'adobe.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'skinceuticals.com',
      domainId: 'skinceuticals.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'promonte.com',
      domainId: 'promonte.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'ph.loreal.com',
      domainId: 'ph.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'odessa.kyivstar.net',
      domainId: 'odessa.kyivstar.net',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'redken.com',
      domainId: 'redken.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'volume.se',
      domainId: 'volume.se',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.no',
      domainId: 'telenor.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'saitcommunications.com',
      domainId: 'saitcommunications.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.com.pk',
      domainId: 'telenor.com.pk',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 've.loreal.com',
      domainId: 've.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'research.att.com',
      domainId: 'research.att.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'us.loreal.com',
      domainId: 'us.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'th.loreal.com',
      domainId: 'th.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'vodafon.com',
      domainId: 'vodafon.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.se',
      domainId: 'telenor.se',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'sky.com.br',
      domainId: 'sky.com.br',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'th.pwc.com',
      domainId: 'th.pwc.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'oz.mt.att.com',
      domainId: 'oz.mt.att.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'png.digi.com.my',
      domainId: 'png.digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'th.ey.com',
      domainId: 'th.ey.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'na.loreal.intra',
      domainId: 'na.loreal.intra',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telway.no',
      domainId: 'telway.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenorbank.pk',
      domainId: 'telenorbank.pk',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'pgsm.hu',
      domainId: 'pgsm.hu',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'my.pwc.com',
      domainId: 'my.pwc.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'utfors.fi',
      domainId: 'utfors.fi',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'talkmore.no',
      domainId: 'talkmore.no',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'softsheen-carson.com',
      domainId: 'softsheen-carson.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'vizada.com',
      domainId: 'vizada.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.co.rs',
      domainId: 'telenor.co.rs',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'sw.digi.com.my',
      domainId: 'sw.digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'urbandecay.com',
      domainId: 'urbandecay.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'pl.loreal.com',
      domainId: 'pl.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'sb.digi.com.my',
      domainId: 'sb.digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.dk',
      domainId: 'telenor.dk',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'my.ey.com',
      domainId: 'my.ey.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'pa.loreal.com',
      domainId: 'pa.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'thebodyshop.com',
      domainId: 'thebodyshop.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'nl.loreal.com',
      domainId: 'nl.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'next.att.com',
      domainId: 'next.att.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'saloncentric.com',
      domainId: 'saloncentric.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.rs',
      domainId: 'telenor.rs',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'nyxcosmetics.com',
      domainId: 'nyxcosmetics.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'zonavi.com',
      domainId: 'zonavi.com',
    },
    {
      thirdPartyOrganizationId: 'reKArxPdTtecx-7gC8eqBA',
      id: 'sanofi.com',
      domainId: 'sanofi.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'pt.loreal.com',
      domainId: 'pt.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'nz.loreal.com',
      domainId: 'nz.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'moremr.com',
      domainId: 'moremr.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenordigital.com',
      domainId: 'telenordigital.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'ru.loreal.com',
      domainId: 'ru.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'rd.loreal.com',
      domainId: 'rd.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.fi',
      domainId: 'telenor.fi',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'sonofon.dk',
      domainId: 'sonofon.dk',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'tse.local',
      domainId: 'tse.local',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'pureology-usa.com',
      domainId: 'pureology-usa.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'vodafone.com',
      domainId: 'vodafone.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'mx.att.com',
      domainId: 'mx.att.com',
    },
    {
      thirdPartyOrganizationId: 'zeJKArTKRR-EkQELjw4U0Q',
      id: 'us.att.com att.com',
      domainId: 'us.att.com att.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telefonselskapet.no',
      domainId: 'telefonselskapet.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'wavemoney.com.mm',
      domainId: 'wavemoney.com.mm',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.hu',
      domainId: 'telenor.hu',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.com.mm',
      domainId: 'telenor.com.mm',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'mobildata.no',
      domainId: 'mobildata.no',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'za.loreal.com',
      domainId: 'za.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.co.yu',
      domainId: 'telenor.co.yu',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'rd.us.loreal.com',
      domainId: 'rd.us.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'taide.net',
      domainId: 'taide.net',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'pannon.hu',
      domainId: 'pannon.hu',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'pk.loreal.com',
      domainId: 'pk.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'vn.loreal.com',
      domainId: 'vn.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'tameerbank.com',
      domainId: 'tameerbank.com',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'mx.loreal.com',
      domainId: 'mx.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telehuset.no',
      domainId: 'telehuset.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'um.digi.com.my',
      domainId: 'um.digi.com.my',
    },
    {
      thirdPartyOrganizationId: 'QO3YDucURpa1RaVxnQjO_w',
      id: 'uk.loreal.com',
      domainId: 'uk.loreal.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.me',
      domainId: 'telenor.me',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telefonselskpet.no',
      domainId: 'telefonselskpet.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'tele2.com',
      domainId: 'tele2.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'telenor.com',
      domainId: 'telenor.com',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'opplysningen.no',
      domainId: 'opplysningen.no',
    },
    {
      thirdPartyOrganizationId: 'IeTlvmY9SSCQouaHi60CQQ',
      id: 'startsiden.no',
      domainId: 'startsiden.no',
    },
  ],
  paging: {},
  linked: {},
};
